var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagonimagemobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4803_7744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6433 8L27.2861 12.7647L27.2861 22.294L18.6433 27.0586L10.0004 22.294L10.0004 12.7647L18.6433 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5004 13.06L18.6433 8.57094L26.7861 13.06L26.7861 21.9987L18.6433 26.4877L10.5004 21.9987L10.5004 13.06Z",
    stroke: "#FF3939"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5377 19.0918L17.4817 17.0458C17.5817 16.9378 17.6677 16.8338 17.7397 16.7338C17.8117 16.6338 17.8657 16.5338 17.9017 16.4338C17.9377 16.3338 17.9557 16.2278 17.9557 16.1158C17.9557 16.0358 17.9397 15.9578 17.9077 15.8818C17.8797 15.8018 17.8337 15.7298 17.7697 15.6658C17.7097 15.6018 17.6357 15.5518 17.5477 15.5158C17.4597 15.4758 17.3577 15.4558 17.2417 15.4558C17.0817 15.4558 16.9437 15.4938 16.8277 15.5698C16.7117 15.6418 16.6217 15.7478 16.5577 15.8878C16.4977 16.0278 16.4677 16.1898 16.4677 16.3738H15.7657C15.7657 16.0738 15.8217 15.8078 15.9337 15.5758C16.0497 15.3398 16.2177 15.1558 16.4377 15.0238C16.6617 14.8878 16.9337 14.8198 17.2537 14.8198C17.4977 14.8198 17.7097 14.8598 17.8897 14.9398C18.0697 15.0158 18.2177 15.1158 18.3337 15.2398C18.4537 15.3638 18.5417 15.4998 18.5977 15.6478C18.6577 15.7958 18.6877 15.9398 18.6877 16.0798C18.6877 16.2998 18.6337 16.5118 18.5257 16.7158C18.4217 16.9198 18.2837 17.1018 18.1117 17.2618L16.9177 18.4318H18.7417V19.0918H15.5377ZM19.5067 14.8918H20.2327V19.0918H19.5067V14.8918ZM21.7927 14.8918H22.6447L20.8747 16.8598L22.7347 19.0918H21.8647L20.0167 16.8778L21.7927 14.8918Z",
    fill: "#FF3939"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4803_7744",
    x: 0,
    y: 0,
    width: 37.2861,
    height: 39.0586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4803_7744"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4803_7744",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonimagemobile);
export default __webpack_public_path__ + "static/media/hexagonimagemobile.db243084c62939add313c1fd36b88c90.svg";
export { ForwardRef as ReactComponent };